import { App, KernelRouteEndpoint, KernelRoute } from "../../../kernel/kernel";
import raf from "raf";
import RouterSessionManagement from "../../controllers/router-session-management";

/**
 * Login route
 *
 * @extends KernelRoute
 */
class FormRoute extends KernelRoute {

    onFail () {
        return window.location = "#not-found";
    }

    onSuccess (formData) {
        System.import("./completed").then(View => {
            const view = new View.default({ params: this.parsedParams, formData: formData });
            raf(_ => App.contentRegion.show(view));
        });
    }

    /**
     * When the user hits the index page, show the index page
     */
    @KernelRouteEndpoint("/completed(/)")
    completedRoute (params) {
        this.parsedParams = this.parseQueryString(params);
        let manager = new RouterSessionManagement();
        if (null != this.parsedParams.referenceNumber) {
            manager.obtainForm(this.parsedParams.referenceNumber, this.onSuccess.bind(this), this.onFail.bind(this));
        } else if (null != this.parsedParams.organisationId) {
            manager.obtainConfig(this.parsedParams.organisationId)
                .then(config => this.onSuccess({ presets: { configuration: config }}))
                .catch(_=> this.onFail());
        } else {
            manager.obtainConfig(this.parsedParams.previewId)
                .then(config => this.onSuccess({ presets: { configuration: config }}))
                .catch(_=> this.onFail());
        }
    }
}

export default FormRoute;



// WEBPACK FOOTER //
// ./public/domain/views/completed/completed.route.js